import { TABS } from "../constants";
import Assistant from "./assistant/Assistant";
import Agenda from "./agenda/Agenda";
import ActionItems from "./actionItems/ActionItems";

/**
 * SessionView - Renders the content for the active session based on the selected tab.
 * The tab header is rendered by Home.jsx.
 */
const SessionView = ({
  selectedTab,
  meetingUuid,
  meetingId,
  rtmsStreamId,
  rtmsStartTime,
  alias,
  role,
  rtmsRequesterName,
  isRtmsStartedByOther,
  showBanner,
  setShowBanner,
  chatMessages,
  setChatMessages,
  isChatLoading,
  setIsChatLoading,
}) => {
  return (
    <>
      {selectedTab === TABS.ASSISTANT && (
        <Assistant
          rtmsRequesterName={rtmsRequesterName}
          isRtmsStartedByOther={isRtmsStartedByOther}
          showBanner={showBanner}
          setShowBanner={setShowBanner}
          meetingUuid={meetingUuid}
          meetingId={meetingId}
          rtmsStreamId={rtmsStreamId}
          rtmsStartTime={rtmsStartTime}
          alias={alias}
          chatMessages={chatMessages}
          setChatMessages={setChatMessages}
          isChatLoading={isChatLoading}
          setIsChatLoading={setIsChatLoading}
        />
      )}
      {selectedTab === TABS.AGENDA && <Agenda />}
      {selectedTab === TABS.ACTION_ITEMS && <ActionItems />}
    </>
  );
};

export default SessionView;
